var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-2 my-2"},[_c('v-card-title',[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('back')}}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1),_vm._v(" Stats ")],1),_c('v-card-text')],1)}
var staticRenderFns = []

export { render, staticRenderFns }